// Locked Tim-approved labels (see resume-sprint prompt 2026-05-22). The DB
// enum is `billing_type` in packages/db/src/schema.ts — keep these arrays in
// the same order so the selector renders predictably.

export const BILLING_TYPES = [
  'hourly',
  'inspection',
  'drawing',
  'crawlspace_fee',
  'far_away_travel',
  'design',
] as const;

export type BillingType = (typeof BILLING_TYPES)[number];

export const BILLING_LABELS: Readonly<Record<BillingType, string>> = {
  hourly: 'Hourly',
  inspection: 'Inspection',
  drawing: 'Drawing',
  crawlspace_fee: 'Crawlspace fee',
  far_away_travel: 'Far-away travel',
  design: 'Design',
};

// Tighter labels for the SessionLog selector where six chips share a single
// mobile row in a 3-column grid. Two are shortened ("Crawlspace fee" ->
// "Crawlspace", "Far-away travel" -> "Travel") so they fit at text-xs on a
// 320 px viewport without truncation. The full BILLING_LABELS are still
// used by BillingSummary, RecentEntries, Rates, and any other surface
// where the written labels are read carefully.
export const BILLING_LABELS_SHORT: Readonly<Record<BillingType, string>> = {
  hourly: 'Hourly',
  inspection: 'Inspection',
  drawing: 'Drawing',
  crawlspace_fee: 'Crawlspace',
  far_away_travel: 'Travel',
  design: 'Design',
};

export function isBillingType(v: string): v is BillingType {
  return (BILLING_TYPES as readonly string[]).includes(v);
}
